import React, {useContext, useEffect, useState} from 'react';
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    customToast, DateFormats,
    DisabledContext, FormInput,
    SubTitle, Text,
    Variants, WidthConstrainedContainer
} from "toolbox-react-frontend-components";
import {cloneDeep} from "lodash";
import LoadingPane from "../../../components/LoadingPane";
import {format, parse} from "date-fns";

const ProfilePage = (props) => {
    const {

    } = props;

    const {
        disabled,
        setDisabled
    } = useContext(DisabledContext);

    const [data, setData] = useState({
        first_name:                 '',
        last_name:                  '',
        email:                      '',
        password:                   '',
        password_confirmation:      '',
        password_last_changed_at:   null,
    });
    const [loaded, setLoaded]           = useState(false);
    const [errors, setErrors]           = useState(null);
    const [submitting, setSubmitting]   = useState(false)

    useEffect(() => {
        loadPageData();
    }, []);

    useEffect(() => {
        if (submitting) {
            submit();
        }
    }, [submitting]);

    const loadPageData = () => {
        axios.get(route('api.admin.profile.edit'))
            .then((response) => {
                if (!!response && !!response.data) {
                    setData({
                        ...response.data,
                        password:               '',
                        password_confirmation:  '',
                    });
                    setLoaded(true);
                    setSubmitting(false);
                    setDisabled(false);
                } else {
                    customToast({
                        title:      'Profile data not found. Please refresh the page to try again.',
                        variant:    Variants.Danger
                    });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const submit = () => {
        setDisabled(true);
        setErrors(null);

        axios.patch(route('api.admin.profile.update'), data)
            .then((response) => {
                customToast({
                    title:      'Profile updated. Reloading...',
                    variant:    Variants.Success
                });

                loadPageData();
            })
            .catch((error) => {
                if (!!error && !!error.response && !!error.response.data) {
                    if (!!error.response.data.message) {
                        customToast({
                            title:      error.response.data.message,
                            variant:    Variants.Danger
                        });
                    }

                    if (!!error.response.data.errors) {
                        setErrors(error.response.data.errors);
                    }

                    setSubmitting(false);
                    setDisabled(false);
                } else {
                    console.log(error);
                    customToast({
                        title:      'An error occurred. Please refresh the page to try again.',
                        variant:    Variants.Danger
                    });
                }
            });
    }

    const updateField = (fieldName, value) => {
        let clone = cloneDeep(data);

        clone[fieldName] = value;

        setData(clone);
    }

    if (!loaded) {
        return (
            <LoadingPane />
        );
    }

    return (
        <WidthConstrainedContainer>
            <Card
                noMargin={true}
            >
                <CardHeader
                    leftSlot={(
                        <SubTitle
                            title={'Edit profile'}
                            noMargin={true}
                        />
                    )}
                />
                <CardBody>
                    <div className={'row m-0 p-0'}>
                        <div className="col-12 col-lg-6 m-0 p-0 pe-lg-2">
                            <FormInput
                                type={'text'}
                                label={'First name'}
                                name={'first_name'}
                                value={data.first_name}
                                errorMessages={!!errors && !!errors.first_name ? errors.first_name : null}
                                onChange={(value) => updateField('first_name', value)}
                                disabled={submitting || disabled}
                            />
                        </div>
                        <div className="col-12 col-lg-6 m-0 p-0 ps-lg-2">
                            <FormInput
                                type={'text'}
                                label={'Last name'}
                                name={'last_name'}
                                value={data.last_name}
                                errorMessages={!!errors && !!errors.last_name ? errors.last_name : null}
                                onChange={(value) => updateField('last_name', value)}
                                disabled={submitting || disabled}
                            />
                        </div>
                    </div>
                    <FormInput
                        type={'email'}
                        label={'Email'}
                        name={'email'}
                        value={data.email}
                        errorMessages={!!errors && !!errors.email ? errors.email : null}
                        onChange={(value) => updateField('email', value)}
                        disabled={submitting || disabled}
                    />
                    <SubTitle
                        title={'Optionally change password'}
                        className={'mt-4'}
                    />
                    <Text>
                        <small>
                            Password last changed at:
                            <br />
                            {!!data.password_last_changed_at ? format(parse(data.password_last_changed_at, DateFormats.DB, new Date()), DateFormats.DATETIME_SHORT): 'never'}
                        </small>
                    </Text>
                    <FormInput
                        type={'password'}
                        label={'Password'}
                        name={'password'}
                        value={data.password}
                        errorMessages={!!errors && !!errors.password ? errors.password : null}
                        onChange={(value) => updateField('password', value)}
                        disabled={submitting || disabled}
                    />
                    <FormInput
                        type={'password'}
                        label={'Confirm Password'}
                        name={'password_confirmation'}
                        value={data.password_confirmation}
                        errorMessages={!!errors && !!errors.password_confirmation ? errors.password_confirmation : (!!errors && !!errors.password ? errors.password : null)}
                        onChange={(value) => updateField('password_confirmation', value)}
                        disabled={submitting || disabled}
                    />
                    <div className={'d-flex align-items-center justify-content-end'}>
                        <Button
                            label={submitting ? 'Updating...' : 'Update'}
                            onClick={(event) => setSubmitting(true)}
                            disabled={submitting || disabled}
                        />
                    </div>
                </CardBody>
            </Card>
        </WidthConstrainedContainer>
    );
}

export default ProfilePage;
